<template>
    <div>
        <el-table
            :data="paginationTableData[currentPage-1]"
            border
            style="width: 100%">
            <el-table-column
                v-for="(item,index) in columnLists"
                :key="index"
                :label="item.label"
                :min-width="item.width?item.width : ''"
                :prop="item.value">
            </el-table-column>
        </el-table>
        <div class="block">
            <el-pagination
                :current-page="currentPage"
                :page-size="pageSize"
                :page-sizes="[10, 20, 30, 50, 100]"
                :total="tableData.length"
                class="table-pagination"
                layout="total, sizes, prev, pager, next"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            paginationTableData: []
        };
    },
    props: {
        columnLists: {
            type: Array,
            default() {
                return [];
            }
        },
        tableData: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val;
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        },
        dataInit() {
            const tableData = [];
            let arr = [];
            this.tableData.map((item, index) => {
                arr.push(item);
                if ((index + 1) % this.pageSize === 0 || index === this.tableData.length - 1) {
                    tableData.push(arr);
                    arr = [];
                }
            });
            this.paginationTableData = tableData;
        }
    },
    created() {
        this.dataInit();
    },
    watch: {
        tableData() {
            this.dataInit();
        },
        pageSize() {
            this.dataInit();
        }
    }
};
</script>
<style lang="less">
.block {
    width: 100%;
    border-top: 1px solid #EBEEF5;
    float: right;

    .table-pagination {
        margin: 10px 0px;
        float: right;
        padding: 0;

        .btn-prev, .btn-next, .el-pager li {
            background-color: #ffffff !important;
            border: 1px solid #cccccc;
            border-radius: 4px !important;
            padding: 0;
            min-width: 30px;
            margin-right: 4px;
        }

        .el-pager li.active + li {
            border-left: 1px solid #cccccc;
        }

        .el-pager li:not(.disabled).active {
            background-color: #00BCBF !important;
            border: 1px solid #00BCBF;
            color: #ffffff;
        }
    }
}
</style>
